import React from 'react';
import ChatBot from 'views/components/chatBot/chatBot';
import Notificaciones from 'views/components/notificaciones/notificaciones';
import './FloatingOverlay.css';

// Componente contenedor para overlays flotantes (notificaciones, chat, etc.)
// Este componente se posiciona fijo en la pantalla y renderiza sus hijos en la esquina inferior derecha.

const FloatingOverlay = ({ notificaciones = [], showNotificaciones = false, showChatBot = false, style }) => {
    return (
        <div className="floatingOverlayContainer" style={style}>
            {showChatBot && <ChatBot triggerClassName="floatingTriggerBtn" />}
            {showNotificaciones && <Notificaciones avisos={notificaciones} triggerClassName="floatingTriggerBtn" />}
        </div>
    );
};

export default FloatingOverlay;
